// @flow
import React, { Component } from 'react'
import { Select, Card, Button, message, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import ReactMarkdown from 'react-markdown'
import {withRouter} from "react-router-dom";
import {getQueryString} from '../../utils/common'
import ApiService from '../../actions/apiService';

class MembershipPackage extends Component<Props> {

  state: State = {
    plan: [{price: '129.95', planLength:'Month'}, {price: '1399.95',planLength:'Year'}],
    planLength: this.props.packageId === '2' ? 'Month' : 'Year',
    price: this.props.packageId === '2' ? '129.95' : '1399.95',
    packageName:'Membership',
    content: '',
    isLoading: true,
  }
  
  async componentWillMount() {
    const coupenCode = getQueryString('couponcode');
    this.getContent();
    if (coupenCode) {
      const response = await ApiService.getMethod(`/purchases/checkcoupon?couponCode=${coupenCode}`);
      if (response && response.validCoupon) {
        const {packageName, price, planLength} = this.state
        const packageId = planLength === "Month" ? 2 : 3;
        this.props.history.push({
          pathname: '/checkout',
          state: {
            packageId: packageId,
            packageName: packageName,
            price: parseFloat(price),
            planLength: planLength,
            planType: 'recurring',
            promoCode: coupenCode,
          }
        })
      } else {
        message.error('Coupen code is not valid!');
      }
    }
  }
  
  getContent = async () => {
    const response = await ApiService.getMethod(`/description/product/membership`);
    if (response) {
      this.setState({
        content: response,
        isLoading: false
      })
    } else {
      this.setState({
        isLoading: false
      })
    }
  }
  
  handleChange = (value) => {
    this.setState({
      planLength: value.label,
      price: value.key,
    })
  }

  handleCart = () => {
    const {packageName, price, planLength} = this.state
    const packageId = planLength === "Month" ? 2 : 3;
    this.props.history.push({
      pathname: '/checkout',
      state: {
        packageId: packageId,
        packageName: packageName,
        price: parseFloat(price),
        planLength: planLength,
        planType: 'recurring'
      }
    })
  }

  render() {
    const { plan, price, planLength, content, isLoading } = this.state
    return (
      <StyledContent>
            <StyledMember>
              <Card title="Membership" bordered={false}>
                {
                  isLoading && <Spin />
                }
                { !isLoading &&
                    <div>
                      <div>
                        <ReactMarkdown escapeHtml={false} source={content || ''}/>
                      </div>
                      <p className="price-title">
                        <span className='month'>For:</span> {price} /
                        <span className='month'>&nbsp; {planLength}</span>
                      </p>
                      <div>
                        <label>Length</label>&nbsp;
                        <Select labelInValue
                                defaultValue={price === '129.95' ? {key: 'Month'} : {key: 'Year'}}
                                style={{width: 100}}
                                onChange={this.handleChange}>
                          {
                            plan.length && plan.map((item, i) => (
                              <Select.Option key={i} value={item.price}>{item.planLength}</Select.Option>
                            ))
                          }
                        </Select>
                      </div>
                      <Button type="primary" size="large" style={{marginTop: 20}} onClick={this.handleCart}>Checkout</Button>
                    </div>
                }
              </Card>
            </StyledMember>
      </StyledContent>
    )
  }
}

export default withRouter(MembershipPackage)



// WEBPACK FOOTER //
// ./src/components/shop-pages/membershipPackage.js